export const modules = {
  auth: {
    login: '/auth/login',
    logout: '/auth/logout',
    signup: '/auth/signup',
    params: {
      token: 'token',
      email: 'email',
    },
  },
};
